import { T } from "../../app/tokens.js";

// Canonical table-header style — Offices baseline.
// Spread TABLE_TH onto every <th> in the app; add per-column overrides
// (e.g. textAlign: "left") after the spread so they win.
export const TABLE_TH = {
  padding:       "10px 14px",
  fontSize:      T.fsXxs,
  fontWeight:    T.fwBold,
  color:         "var(--v2-mid)",
  letterSpacing: ".07em",
  textTransform: "uppercase",
  textAlign:     "center",
  borderBottom:  "1px solid var(--v2-line)",
  background:    "var(--v2-tint)",
  whiteSpace:    "nowrap",
  userSelect:    "none",
};

// Shared sort-direction caret — 11×11 SVG polyline, matching Offices/Leases.
// active=true  → T.timelineBlue, strokeWidth 3, opacity 1
// active=false → T.mid, strokeWidth 2.5, opacity 0.25 (always rendered)
// dir=1 for ascending (↑), dir=-1 for descending (↓).
export function TableSortCaret({ active, dir = 1, testId, style }) {
  if (active) {
    return (
      <svg
        aria-hidden="true"
        data-testid={testId}
        width="11"
        height="11"
        viewBox="0 0 24 24"
        fill="none"
        stroke={T.timelineBlue}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ marginLeft: "3px", verticalAlign: "-2px", flexShrink: 0, ...style }}
      >
        {dir > 0
          ? <polyline points="18 15 12 9 6 15" />
          : <polyline points="6 9 12 15 18 9" />}
      </svg>
    );
  }
  return (
    <svg
      aria-hidden="true"
      data-testid={testId}
      width="11"
      height="11"
      viewBox="0 0 24 24"
      fill="none"
      stroke={T.mid}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ marginLeft: "3px", verticalAlign: "-2px", flexShrink: 0, opacity: 0.25, ...style }}
    >
      <polyline points="18 15 12 9 6 15" />
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}
